import {find} from 'lodash'

/* Utils */
import {generateVariantState, getUnAvailableVariants, getAvailableVariants} from '../../modules/variant/variantUtils'

// eslint-disable-next-line consistent-return
function currencyInt(price, removeCommas = false) {
  let crrncy;
  try {
    crrncy = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      ...removeCommas && {minimumFractionDigits: 0, maximumFractionDigits: 0},
    }).format(price / 100);
    return crrncy.replace(/[^0-9.,]/g, '');
  } catch (e) {
    console.error('Error', e?.message)
  }
}

function getIsAvailableProduct({product, activeVariant}) {
  return !product?.isBundle && product?.isInStock && (activeVariant ? activeVariant?.hasCombination === true : true)
}

function generateDefaultInitialProductState() {
  return {
    product: null,
    breadcrumbs: [],
    isAdultProduct: false,
    isAdultProductCookie: false,
    orderedLayoutComponents: [],
    buyback: null,
    tabsModalVisible: false,
    tabsModalIndex: 0,
    campaignDetail: null,
    selectedVasProduct: null,
    popularKeyword: [],
    isVasExists: false,
    vas: [],
    vasLoading: true,
    isLoading: false,
    variants: [],
    returnPolicyInformation: null,
    activeVariant: {},
    allVariantCombinations: [],
    unAvailableVariants: [],
    paymentOptions: [],
    isAvailableProduct: true,
    sizeChart: null,
    webtrekkData: null,
    payments: [],
    isLoadingPayments: true,
    energyClassBadge: null,
    dueDate: [],
    dueDateProducts: [],
    deliveryTooltips: null,
    allListings: [],
    tabActiveIndex: 0,
    campaigns: [],
    campaignEvaluateResult: null,
    bundleCampaign: null,
    otherSellersCampaigns: null,
    otherSellerCoupon: [],
    otherSellerCampaign: [],
    allOtherSellerCampaign: [],
    winnerCampaignName: null,
    comparedProducts: [],
    loyaltyInfoPending: true
  };
}

function productReducer(state = generateDefaultInitialProductState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_BASIC_PRODUCT_FULFILLED':
    case 'GET_PRODUCT_FULFILLED': {
      const responseData = action?.payload?.response?.data?.data;

      const {variants, activeVariant} = generateVariantState({
        variants: responseData?.product?.priceBaseVariantList,
        variantDisplayTypes: responseData?.product?.variantDisplayTypes
      })
      const isAvailableProduct = getIsAvailableProduct({
        product: responseData?.product,
        activeVariant
      })
      const allVariantCombinations = getAvailableVariants({
        combinedVariants: responseData?.product?.combinedVariants,
      })
      const unAvailableVariants = getUnAvailableVariants(allVariantCombinations)

      newState = {
        ...state,
        product: responseData?.product,
        breadcrumbs: responseData?.breadcrumbs,
        isAdultProduct: responseData?.product?.isAdultProduct,
        orderedLayoutComponents: responseData?.orderedLayoutComponents,
        buyback: responseData?.buyback,
        campaignDetail: responseData?.campaignDetail,
        chatOptions: responseData?.chatOptions,
        seoInformation: responseData?.seoInformation,
        popularKeyword: responseData?.popularKeyword,
        fashionReviewSummary: responseData?.fashionReviewSummary,
        paymentOptions: responseData?.product?.paymentOptions,
        productStructuredData: responseData?.seoInformation?.productStructuredData,
        isVasExists: responseData?.isVasExists,
        energyClassBadge: responseData?.energyClassBadge,
        webtrekkData: responseData?.webtrekkData,
        isLoading: false,
        variants,
        activeVariant,
        isAvailableProduct,
        unAvailableVariants,
        allVariantCombinations
      };

      break;
    }

    case 'UPDATE_PRODUCT_VARIANT': {
      const {variant} = action.payload;
      const values = {
        ...state.activeVariant.values,
        [variant.name]: variant.value,
      }
      const variantCombination = find(state.allVariantCombinations, values)

      const newActiveVariant = {
        ...state.activeVariant,
        sku: variantCombination?.sku,
        urlName: variantCombination?.urlName,
        hasCombination: Boolean(variantCombination?.sku),
        values,
      }

      const isAvailableProduct = getIsAvailableProduct({
        product: state?.product,
        activeVariant: newActiveVariant
      })

      newState = {
        ...state,
        isAvailableProduct,
        activeVariant: newActiveVariant,
      }

      break;
    }

    case 'SET_PRODUCT_ADULT': {
      newState = {
        ...state,
        isAdultProduct: action?.payload?.payload || false,
      };

      break;
    }

    case 'SET_LOYALTY_INFO': {
      newState = {
        ...state,
        isPremium: action?.payload?.data?.isPremium,
        loyaltyInfoPending: false
      };

      break;
    }

    case 'SET_PRODUCT_ADULT_COOKIE': {
      newState = {
        ...state,
        isAdultProductCookie: action?.payload?.payload
      };

      break;
    }

    case 'SET_TABS_MODAL_VISIBLE': {
      newState = {
        ...state,
        tabsModalVisible: action?.payload?.isVisible,
        tabsModalIndex: action?.payload?.index,
      };

      break;
    }

    case 'GET_DESKTOP_TABS_FULFILLED': {
      newState = {
        ...state,
        tabActiveIndex: action?.triggerPayload?.index,
      };

      break;
    }

    case 'GET_VAS_FULFILLED': {
      const responseData = action?.payload?.response?.data;

      newState = {
        ...state,
        vas: state.vas = responseData,
        vasLoading: false,
      };

      break;
    }

    case 'SET_ADD_VAS_PRODUCT': {
      newState = {
        ...state,
        selectedVasProduct: state.selectedVasProduct = {
          ...action.payload.params
        }
      };

      break;
    }

    case 'SET_REMOVE_VAS_PRODUCT': {
      newState = {
        ...state,
        selectedVasProduct: state.selectedVasProduct = null
      };

      break;
    }

    case 'SET_REMOVE_ALL_VAS_PRODUCT': {
      newState = {
        ...state,
        selectedVasProduct: state.selectedVasProduct = null
      };

      break;
    }

    case 'SET_PRODUCT_IS_LOADING': {
      newState = {
        ...state,
        isLoading: action.payload.isLoading
      };

      break;
    }

    case 'GET_PRODUCT_RETURN_POLICY_FULFILLED': {
      const responseData = action?.payload?.response?.data?.data;
      newState = {
        ...state,
        returnPolicyInformation: responseData
      };

      break;
    }

    case 'GET_PRODUCT_LISTINGS_FULFILLED': {
      const responseData = action?.payload?.response?.data?.data?.listings;
      newState = {
        ...state,
        allListings: responseData
      };

      break;
    }

    case 'GET_SIZE_CHART_FULFILLED': {
      const responseData = action?.payload?.response?.data?.data;
      newState = {
        ...state,
        sizeChart: responseData
      };

      break;
    }

    case 'GET_CARD_AND_INSTALLMENT_FULFILLED': {
      const paymentOptions = []
      const responseData = action?.payload?.response?.data?.data;
      if (responseData && responseData?.instalmentDetail && responseData?.instalmentDetail?.cardInstallment > 0 && responseData?.instalmentDetail?.cardAmount > 0) {
        paymentOptions.push({
          type: 'Installments',
          imageUrl: 'https://images.hepsiburada.net/banners/1/imageUrl2055_20240605150238.png',
          rowText: `Ayda ${currencyInt(responseData?.instalmentDetail?.cardAmount)} TL'den başlayan, ${responseData?.instalmentDetail?.cardInstallment} ay taksitle`,
          text: `Ayda <b>${currencyInt(responseData?.instalmentDetail?.cardAmount)} TL</b>’den başlayan, ${responseData?.instalmentDetail?.cardInstallment} ay taksitle`,
          desktopRowText: `Ayda ${currencyInt(responseData?.instalmentDetail?.cardAmount)} TL’den başlayan ${responseData?.instalmentDetail?.cardInstallment} ay taksitle`,
          desktopText: `Ayda <b>${currencyInt(responseData?.instalmentDetail?.cardAmount)} TL</b>’den başlayan ${responseData?.instalmentDetail?.cardInstallment} ay taksitle`,
          buttonText: 'İncele',
          buttonTextDesktop: 'Taksit fırsatlarını gör',
        })
      }

      if (responseData && responseData?.instalmentDetail && responseData?.instalmentDetail?.loanInstallment > 0 && responseData?.instalmentDetail?.loanAmount > 0) {
        paymentOptions.push({
          type: 'LoanOffer',
          imageUrl: 'https://images.hepsiburada.net/banners/1/imageUrl2165_20240605145932.png',
          rowText: `Ayda ${currencyInt(responseData?.instalmentDetail?.loanAmount)} TL'den başlayan, ${responseData?.instalmentDetail?.loanInstallment} ay taksitle`,
          text: `Ayda <b>${currencyInt(responseData?.instalmentDetail?.loanAmount)} TL</b>’den başlayan, ${responseData?.instalmentDetail?.loanInstallment} ay taksitle`,
          desktopRowText: `Alışveriş kredisi ile ayda ${currencyInt(responseData?.instalmentDetail?.loanAmount)} TL’den başlayan ${responseData?.instalmentDetail?.loanInstallment} taksitle`,
          desktopText: `Alışveriş kredisi ile ayda <b>${currencyInt(responseData?.instalmentDetail?.loanAmount)} TL</b>’den başlayan ${responseData?.instalmentDetail?.loanInstallment} taksitle`,
          buttonText: 'İncele',
          buttonTextDesktop: 'Kredi fırsatlarını gör',
        })
      }

      if (responseData && responseData?.bnplDetail && responseData?.bnplDetail?.installmentPayment > 0) {
        paymentOptions.push({
          type: 'BuynowPayLater',
          imageUrl: 'https://images.hepsiburada.net/banners/1/imageUrl2146_20240605145815.png',
          rowText: `Ayda ${currencyInt(responseData?.bnplDetail?.installmentPayment)} TL'den başlayan taksitle`,
          text: `Ayda <b>${currencyInt(responseData?.bnplDetail?.installmentPayment)} TL</b>’den başlayan taksitle`,
          desktopRowText: `Alışveriş kredisi ile ayda ${currencyInt(responseData?.bnplDetail?.installmentPayment)} TL'den başlayan taksitle`,
          desktopText: `Alışveriş kredisi ile ayda <b>${currencyInt(responseData?.bnplDetail?.installmentPayment)} TL</b>’den başlayan taksitle`,
          buttonText: 'İncele',
          buttonTextDesktop: 'Taksit fırsatlarını gör',
        })
      }

      if (state?.product?.tagLabelPaymentOptions?.length > 0) {
        paymentOptions.sort(function(a, b) {
          return state?.product?.tagLabelPaymentOptions?.find(item => item?.type === a.type)?.order - state?.product?.tagLabelPaymentOptions?.find(item => item?.type === b.type)?.order;
        });
      }

      newState = {
        ...state,
        payments: paymentOptions,
        isLoadingPayments: false
      };

      break;
    }

    case 'GET_CAMPAIGNS_PDP_DASHBOARD_FULFILLED': {
      const responseData = action?.payload?.response?.data;
      const campaigns = responseData?.campaigns?.campaignTabDetailList || [];
      const allCampaigns = [
        ...campaigns?.discountCampaignList || [],
        ...campaigns?.freeProductCampaignList || [],
        ...campaigns?.specialCampaignList || [],
        ...campaigns?.bundleCampaigns || [],
        ...campaigns?.freeShippingCampaignList || [],
      ];

      let availableFinalPrice = responseData?.campaignEvaluateResult?.evaluateAsPremiumResult?.discountedAmount || responseData?.campaignEvaluateResult?.evaluateResult?.discountedAmount || null;
      let finalPrice = Number(availableFinalPrice);
      let finalPriceFormatted = Math.round(finalPrice * 100).toString();

      newState = {
        ...state,
        campaigns: allCampaigns,
        campaignEvaluateResult: responseData?.campaignEvaluateResult,
        bundleCampaign: campaigns?.bundleCampaignList,
        otherSellersCampaigns: responseData?.otherSellersCampaigns,
        winnerCampaignName: responseData?.campaigns?.winnerCampaignName,
        campaignEvaluateFinalPrice: availableFinalPrice ? finalPriceFormatted : null
      };
      break;
    }

    case 'GET_OTHER_SELLER_COUPON_FULFILLED': {
      const responseData = action?.payload?.response?.data?.data;
      newState = {
        ...state,
        otherSellerCoupon: responseData
      };
      break;
    }

    case 'GET_OTHER_SELLER_CAMPAIGN_FULFILLED': {
      const responseData = action?.payload?.response?.data?.result;
      newState = {
        ...state,
        allOtherSellerCampaign: responseData?.map((item) => ({
          merchantId: item?.merchantId,
          campaignCount: item?.count
        }))
      };
      break;
    }

    case 'GET_DELIVERY_TOOLTIPS_FULFILLED': {
      const responseData = action?.payload?.response?.data?.data?.[0]
      newState = {
        ...state,
        deliveryTooltips: responseData
      }

      break
    }

    case 'GET_DUE_DATE_FULFILLED': {
      const responseData = action?.payload?.response?.data
      newState = {
        ...state,
        dueDate: responseData
      }

      break
    }

    case 'GET_DUE_DATE_PRODUCTS_FULFILLED': {
      const responseData = action?.payload?.response?.data;

      newState = {
        ...state,
        dueDateProducts: state.dueDateProducts
          ? [...state.dueDateProducts, ...responseData]
          : responseData
      };

      break;
    }

    case 'LEAVE_PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID_ROUTE':
    case 'LEAVE_PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU_ROUTE': {
      newState = {
        ...state,
        ...generateDefaultInitialProductState()
      };

      break;
    }

    case 'GET_KEYWORDS_FOR_PRODUCT_DETAIL_PAGE_FULFILLED': {
      newState = {
        ...state,
        popularKeyword: action.payload.response.data.data
      };
      break;
    }

    case 'GET_CARD_AND_INSTALLMENT_REJECTED': {
      newState = {
        ...state,
        payments: [],
        isLoadingPayments: false
      };
      break;
    }

    case 'GET_COMPARED_PRODUCTS_FULFILLED': {
      const comparedProducts = action?.payload?.response?.data?.data?.products || [];

      newState = {
        ...state,
        comparedProducts
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default productReducer
export {generateDefaultInitialProductState}
